<template>
  <div class="downLoad">
    <div class="title">
        <p class="one">欢迎参加上汽集团内部尊享体验</p>
        <p class="two">请您填写您的所属公司及姓名</p>
    </div>
    <mt-field label="公司" placeholder="请输入本人所属公司"  type="text" class="company" v-model="applyData.form.company"></mt-field>
    <mt-field label="姓名" placeholder="请输入本人真实姓名"  type="text" class="name" v-model="applyData.form.name"></mt-field>
     <mt-button class="btn" @click="submit">提交</mt-button>
  </div>
</template>

<script>
import { singUp } from '@/data/api/experince'
import Cookie from '@/common/utils/Cookie.js'
import UpdateLogData from '@/data/api/common/Log/UpdateLogData.js'
export default {
  name: 'ExperienceApplyPage',
  data () {
    return {
      applyData: {
        form: {
          company: '',
          name: ''
        }
      }
    }
  },
  mounted () {
    UpdateLogData({path: this.$route.path, action: 'finishLoad', query: this.$route.query, hasRedPacket: false})
  },
  methods: {
    submit: function () {
      UpdateLogData({path: this.$route.path, action: 'submit', hasRedPacket: false})
      if (!Cookie.get('Admin-Token')) {
        //  获取不到token => 未登录
        this.$mint.MessageBox.alert('请先登录！').then(_ => {
          // this.$router.push('/experience')
          window.location.href = window.location.pathname + '#/experience'
          document.title = '体验官招募令'
        })
        return
      }
      if (this.applyData.form.name && this.applyData.form.company) {
        this.$mint.Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        singUp(this.applyData.form).then((res) => {
          window.location.href = window.location.pathname + '#/experienceExplist' + `?channel=${this.$route.query.channel}`
          document.title = '首席体验官招募令'
        }).catch(() => {}).finally(() => {
          this.$mint.Indicator.close()
        })
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.downLoad{
  width: 100%;
  position: absolute;
  top: 0;
  left:0;
  bottom: 0;
  background-image: url('../../assets/images/apply.jpg');
  background-repeat:no-repeat;
  background-color:#00b9b4;
  background-position:left bottom;
  background-size: cover;
  .title{
      color:#fff;
      .one{
          width:100%;
          text-align :center;
          margin-top:70px;
          font-size:24px;
          font-weight :bold;
          text-shadow :0 1px 1px grey
      }
      .two{
          width:100%;
          text-align:center;
          margin-top:15px;
          font-size:15px;
          font-weight :bold;
          text-shadow :0 1px 1px grey
      }
  }
  .company{
      width:88%;
      margin:60px 6% 0 6%
      height:60px;
      border-radius :5px
      font-size:14px;
      >>>.mint-cell-title{
          width:45px
      }
      >>>..mint-field-core{
          font-size:14px;
      }
  }
  .name{
      width:88%;
      margin:20px 6% 0 6%
      height:60px;
      border-radius :5px
      >>>.mint-cell-title{
          width:45px
      }
      >>>..mint-field-core{
          font-size:14px;
      }
  }
  .btn{
      background :#00b2a9
      color:#fff;
      font-size:16px;
      letter-spacing: 10px;
      width:88%;
      height:60px;
      margin:40px 6% 0 6%
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Experience/apply.vue